import { NavLink } from 'react-router-dom';

const TABS = [
  { slug: 'users', label: 'Users' },
  { slug: 'entitlements', label: 'Entitlements' },
  { slug: 'identity', label: 'Identity' },
  { slug: 'microsoft', label: 'Microsoft' },
];

/** Sub-navigation across the per-customer admin pages. */
export function CustomerTabs({ customerOrgId }: { customerOrgId: string }) {
  return (
    <nav className="tabs" aria-label="Customer sections">
      {TABS.map((t) => (
        <NavLink
          key={t.slug}
          to={`/tipsconnect/admin/customers/${customerOrgId}/${t.slug}`}
          className={({ isActive }) => `tab${isActive ? ' tab--active' : ''}`}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
